export const BSA_REPORT_GENERATION_FAILED_MESSAGE = "Couldn't generate the analysis report. Please try again.";
export const BSA_REPORT_DOWNLOAD_FAILED_MESSAGE = "Couldn't download the analysis report. Please try again.";
export const BSA_REPORT_VIEWER_HEADING = 'Bank Statement Analysis Report';
// UW always returns a .xlsx; used as the fallback extension for MIME resolution
// when the returned fileName has no usable extension.
export const BSA_REPORT_FILE_EXTENSION = 'xlsx';
